export default {
  path: '/servico-av/:service_id/medidor/:meter_id',
  component: () => import('@/components/pages/AutoVerificationSteps')
}
